/** 
 * Meta-données de fonctions analysis
 * @description Provient du server
 */
export default class AnalysisMetaDataAttribute {
	/** Liste des exports disponibles sur la fonction */
	ExportTypes: string[] = [];
}
